module.exports = __webpack_public_path__ + "static/media/LogicWheel2_2_drag_1.c06db626.png";